import React from "react";
import { Card } from "@/components/erp/ui";

export const weekendStats = (d) => d.rows.map((r) => {
  const wk = d.days.filter((x) => x.weekday >= 5);
  const scheduled = wk.filter((x) => (r.cells[x.date].shift || "").includes("–")).length;
  const attended = wk.filter((x) => ["HADIR", "TELAT", "TELAT_DIMAAFKAN"].includes(r.cells[x.date].status)).length;
  return { id: r.employee_id, name: r.name, sub: `${r.group} · ${r.category}`, scheduled, attended };
});

export const WeekendRecap = ({ d }) => {
  const rows = weekendStats(d).sort((a, b) => b.scheduled - a.scheduled || b.attended - a.attended);
  if (!rows.length) return null;
  const avg = rows.reduce((s, x) => s + x.scheduled, 0) / rows.length;
  const max = Math.max(1, ...rows.map((x) => Math.max(x.scheduled, x.attended)));
  return (
    <Card className="p-5 mt-5" data-testid="weekend-recap">
      <div className="flex flex-wrap items-baseline gap-2 mb-3">
        <span className="font-semibold text-sm">Rekap Giliran Sabtu–Minggu · {d.month}</span>
        <span className="text-xs text-slate-500" data-testid="weekend-avg">Rata-rata {avg.toFixed(1)} hari dijadwalkan per orang</span>
      </div>
      <div className="space-y-2">
        {rows.map((x) => {
          const diff = x.scheduled - avg;
          const tone = diff >= 1 ? "text-rose-600" : diff <= -1 ? "text-sky-600" : "text-slate-500";
          return (
            <div key={x.id} className="flex items-center gap-3 text-sm" data-testid={`weekend-row-${x.id}`}>
              <div className="w-32 sm:w-48 shrink-0"><div className="font-medium truncate">{x.name}</div><div className="text-[10px] text-slate-400 truncate">{x.sub}</div></div>
              <div className="flex-1 min-w-0">
                <div className="h-2.5 rounded-full bg-slate-100 overflow-hidden"><div className="h-full bg-slate-800" style={{ width: `${(x.scheduled / max) * 100}%` }} /></div>
                <div className="h-1.5 mt-1 rounded-full bg-slate-100 overflow-hidden"><div className="h-full bg-emerald-500" style={{ width: `${(x.attended / max) * 100}%` }} /></div>
              </div>
              <div className="w-32 text-right text-xs shrink-0 whitespace-nowrap">
                <span data-testid={`weekend-sched-${x.id}`} className="font-semibold">{x.scheduled}</span> jadwal · <span data-testid={`weekend-att-${x.id}`} className="text-emerald-600">{x.attended}</span> masuk
                <div className={`text-[10px] ${tone}`}>{diff >= 1 ? "di atas rata-rata" : diff <= -1 ? "di bawah rata-rata" : "seimbang"}</div>
              </div>
            </div>
          );
        })}
      </div>
      <p className="text-[11px] text-slate-400 mt-3">Batang gelap = hari Sabtu/Minggu yang dijadwalkan masuk; hijau = benar-benar absen masuk. Gunakan untuk membagi giliran berikutnya ke yang di bawah rata-rata.</p>
    </Card>
  );
};
